// extracted by mini-css-extract-plugin
export var dropdownButton = "_1t-0";
export var fullWidthDropdownButton = "_1t-1";
export var icon = "_1t-3";
export var iconPlaceholder = "_1t-2";
export var menuItemRow = "_1t-5";
export var shortcutContainer = "_1t-4";